import {Link} from "react-router-dom";

const AdminDashboard = () => {
    return (
        <>
            <div className="container p-5 m-5 font-link">
                <div className="d-flex justify-content-center align-content-center p-2">
                    <Link to="/create_post" className="btn btn-primary btn-lg text-light text-center fw-bolder m-2">
                        ایجاد پست جدید در بلاگ
                    </Link>

                    <Link to="/create_category" className="btn btn-primary btn-lg text-light text-center fw-bolder m-2">
                        ایجاد دسته بندی جدید در مطالب
                    </Link>
                </div>

            </div>
        </>
    )
}

export default AdminDashboard;